<!--批量下载轨迹-->
<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>运单管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>批量下载轨迹</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">时间段</span>
        <el-select style="width: 120px" v-model="filter.timeType" placeholder="请选择">
          <el-option v-for="item in timeTypeList" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="filter.startTime"
          type="datetime"
          placeholder="选择开始时间"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="filter.endTime"
          type="datetime"
          placeholder="选择结束时间"
          default-time="23:59:59"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item" id="auto-1">
        <el-popover
          ref="popover1"
          placement="top-start"
          width="240"
          trigger="focus"
          content="搜索运单号、车牌号、司机姓名"
        >
        </el-popover>
        <span class="item-label">筛选条件</span>
        <el-input
          v-model.trim="filter.keyword"
          v-popover:popover1
          style="width: 320px"
          :maxlength="ordernumberKeywordLimit"
          placeholder="搜索运单号、车牌号、司机姓名"
        >
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-2">
        <span class="item-label">运单状态</span>
        <el-select style="width: 120px" v-model="filter.orderStatus" placeholder="请选择">
          <el-option v-for="item in orderStateList" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item" id="auto-3">
        <span class="item-label">批量搜索</span>
        <el-input
          @click.native="handleShowMore"
          :readonly="true"
          v-model="batchSearchValShow"
          style="width: 260px"
          placeholder="车牌、司机、手机号、运单号"
          :title="batchSearchValShow"
        >
          <i slot="suffix" class="batch-search-icon"></i>
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-4">
        <span class="item-label">装货地名称</span>
        <el-input v-model="filter.loadAddress" style="width: 260px" placeholder="请输入装货地"> </el-input>
      </div>
      <div class="toolbar-item" id="auto-4">
        <span class="item-label">卸货地名称</span>
        <el-input v-model="filter.unloadAddress" style="width: 260px" placeholder="请输入卸货地"> </el-input>
      </div>
      <div class="toolbar-item" id="auto-11">
        <span class="item-label">票号</span>
        <el-input
          placeholder="请输入票号"
          style="width: 260px"
          :maxlength="32"
          clearable
          v-model.trim="filter.billNum"
        ></el-input>
      </div>
      <div class="toolbar-item">
        <el-button type="primary" size="small" @click="handleSearch" id="auto-4">筛选</el-button>
        <el-button size="small" @click="handleResetSearch" id="auto-5">清除条件</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 批量下载轨迹 </span>
      </div>
      <div class="fr">
        <el-button type="primary" size="small" @click="openBill">根据票号下载</el-button>
        <el-popover width="80" trigger="hover" placement="top">
          <p class="text-c order-selected-num">已选{{ multiselectList.length }}条</p>
          <el-button
            class="mr-5 ml-5"
            slot="reference"
            id="auto-6"
            type="primary"
            size="small"
            :disabled="multiselectList.length === 0"
            @click="handleDownloadBatch"
            >批量下载</el-button
          >
        </el-popover>
        <!--暂时屏蔽-->
        <!-- <el-button
                    id="auto-7"
                    plain
                    type="primary"
                    size="small"
                    @click="handleDownloadAll"
                    :disabled="tableData.total === 0"
                    >全部下载</el-button
                > -->
        <!-- <el-button id="auto-8" plain size="small" type="primary" @click="handleMangeDownload">下载管理</el-button> -->
        <el-button id="auto-9" plain size="small" @click="handleViewTrackStyle">查看轨迹样式</el-button>
      </div>
    </div>
    <div class="table-custom-box" id="auto-10">
      <el-table :data="tableData.data" border @selection-change="multiselect" ref="multipleTable">
        <el-table-column type="selection" width="40" :selectable="isSelect"> </el-table-column>
        <el-table-column label="运单号" min-width="120">
          <template v-slot="scope">
            <span class="font-green pointer" @click="showOrderDetail(scope.row)">{{ scope.row.orderNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="运单状态" prop="orderStatusDesc" min-width="90"> </el-table-column>
        <el-table-column label="装货地" prop="loadingAddress" min-width="125" show-overflow-tooltip> </el-table-column>
        <el-table-column label="卸货地" prop="unloadingAddress" min-width="125" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="stockUnit" label="重量/体积" min-width="90"> </el-table-column>
        <el-table-column prop="driverName" label="承运司机" min-width="90"> </el-table-column>
        <el-table-column prop="plateNumber" label="车牌号码" min-width="90"> </el-table-column>
        <el-table-column prop="driverMobile" label="手机号" min-width="90"> </el-table-column>
        <el-table-column prop="holderName" label="下单" min-width="90"> </el-table-column>
        <el-table-column label="操作" min-width="70" align="center">
          <template v-slot="scope">
            <el-button
              type="text"
              v-if="scope.row.supportDownload"
              class="font-size12 font-blue"
              @click="handleDownload(scope.row)"
              >下载</el-button
            >
            <span v-else class="font-red">暂不支持下载</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-fix">
      <el-pagination
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="tableData.total"
        :page-sizes="[20, 50, 100]"
        @current-change="currentChange"
        @size-change="handleSizeChange"
        layout="total, sizes,prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!--批量搜索框s-->
    <el-dialog
      title="批量搜索"
      :visible.sync="batchSearchVisable"
      :close-on-click-modal="false"
      custom-class="batchSearch-custom-dialog"
    >
      <div class="dialog-fee-con">
        <el-radio-group v-model="batchSearchType">
          <el-radio :label="item.val" v-for="item in batchSearchTypeList" :key="item.val">{{ item.name }}</el-radio>
        </el-radio-group>
        <el-input
          class="mt-10"
          type="textarea"
          :rows="4"
          placeholder="批量输入搜索信息，信息用'、'或换行隔开；每次最多允许1000条"
          v-model.trim="batchSearchVal"
        >
        </el-input>
        <p v-if="batchSearchTypeErr" class="font-red">请选择搜索类型</p>
        <p v-if="!batchSearchTypeErr && batchSearchValErr" class="font-red">请输入批量搜索信息</p>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="handleBatchSearch">批量搜索</el-button>
      </div>
    </el-dialog>
    <!--批量搜索框e-->

    <!--下载管理s-->
    <el-dialog :visible.sync="showDownloadTask" title="下载管理">
      <el-table :data="downloadData.data" border :max-height="tableHeight">
        <el-table-column label="下载条数" prop="fileCount"> </el-table-column>
        <el-table-column label="开始时间" prop="beginTime">
          <template v-slot="scope">
            {{ scope.row.beginTime | stamp2TextDateFull }}
          </template>
        </el-table-column>
        <el-table-column label="结束时间" prop="endTime">
          <template v-slot="scope">
            {{ scope.row.endTime | stamp2TextDateFull }}
          </template>
        </el-table-column>
        <el-table-column label="申请人" prop="applyName"> </el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <span v-if="scope.row.status === 1" class="font-gray">打包中</span>
            <el-button
              type="text"
              v-else-if="scope.row.status === 2"
              class="font-blue"
              @click="hanldeDownloadPackage(scope.row)"
              >下载</el-button
            >
            <span v-else-if="scope.row.status === 3" class="font-red">打包失败</span>
            <span v-else-if="scope.row.status === 9" class="font-ca">已失效</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-fix mt-10 pagination-fix-download">
        <el-pagination
          :page-size="downloadPageSize"
          :current-page.sync="downloadCurrentPage"
          :total="downloadData.total"
          @current-change="downloadCurrentChange"
          layout="total, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div slot="footer">
        <el-button @click="showDownloadTask = false">关闭</el-button>
      </div>
    </el-dialog>
    <!--下载管理e-->
    <!-- 票号下载 -->
    <el-dialog title="根据票号下载" :visible.sync="billNumDialogVisible" :close-on-click-modal="false" width="400px">
      <el-input
        placeholder="批量输入票号，票号用'、'或换行隔开：每次最多允许100条"
        type="textarea"
        v-model.trim="billNumStr"
      ></el-input>
      <span slot="footer">
        <el-button @click="billNumDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleBillNumDownload" :disabled="!billNumStr">确 定</el-button>
      </span>
    </el-dialog>
    <!--查看轨迹样式s-->
    <el-dialog
      title="轨迹样式"
      :visible.sync="orderTrackVisble"
      :close-on-click-modal="false"
      custom-class="orderTrack-custom-dialog"
    >
      <div class="order-track-map">
        <img src="../../assets/img/order/ordertrack_style.png" />
      </div>
    </el-dialog>
    <!--查看轨迹样式e-->
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:11
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/order.new.api';
import dateLimit from '@/api/dateLimit';
import config from '@/assets/js/config';
export default {
  name: 'BacthOrderTrack',
  data: function () {
    return {
      currentPage: 1,
      pageSize: 20,
      downloadCurrentPage: 1,
      downloadPageSize: 20,
      filter: {
        timeType: 1,
        startTime: new Date(dateLimit.getThreeMonth()).getTime(),
        endTime: dateLimit.currentDayEnd.getTime(),
        keyword: '',
        orderStatus: 0,
        billNum: '',
        batchSearchVal: '', // 批量搜索类型
        batchSearchType: '' // 批量搜索值
      },
      cache: {},
      timeTypeList: [
        { label: '下单日期', value: 1 },
        { label: '收单日期', value: 2 }
      ],
      orderStateList: [
        { label: '全部', value: 0 },
        { label: '待卸货签到', value: 4 },
        { label: '待签收', value: 5 },
        { label: '待复核', value: 6 },
        { label: '已完成', value: 8 },
        { label: '协商待处理', value: 7 },
        { label: '取消待处理', value: 9 }
      ],
      tableData: {
        data: [],
        total: 0
      },
      downloadData: {
        data: [],
        total: 0
      },
      batchSearchTypeList: [
        { val: 1, name: '车牌' },
        { val: 2, name: '司机手机' },
        { val: 3, name: '司机姓名' },
        { val: 4, name: '运单号' }
      ],
      orderTrackVisble: false,
      batchSearchVisable: false,
      batchSearchTypeErr: false,
      batchSearchValErr: false,
      batchSearchVal: '', // 弹框批量搜索类型
      batchSearchType: '', //   弹框批量搜索值
      batchSearchValShow: '',
      multiselectList: [],
      showDownloadTask: false,
      tableHeight: 500,
      billNumDialogVisible: false,
      billNumStr: '',
      pickerTime: {
        disabledDate: time => {
          if (time > dateLimit.currentDayEnd.getTime()) {
            return true;
          }
          return false;
        }
      }
    };
  },
  created: function () {
    this.handleSearch();
  },
  mounted() {
    let height = document.documentElement.clientHeight - 280;
    this.tableHeight = height;
  },
  watch: {
    batchSearchType(val) {
      if (val) this.batchSearchTypeErr = false;
    },
    batchSearchVal(val) {
      if (val) this.batchSearchValErr = false;
    }
  },
  methods: {
    handleSearch() {
      if (!WUYI.checkDate(this.filter.startTime, this.filter.endTime)) return;
      this.cache = { ...this.filter };
      if (!this.cache.batchSearchType) delete this.cache.batchSearchType;
      this.currentPage = 1;
      this.axiosRequest();
    },
    handleResetSearch() {
      for (const key in this.filter) {
        this.filter[key] = '';
      }
      this.filter.startTime = new Date(dateLimit.getThreeMonth()).getTime();
      this.filter.endTime = dateLimit.currentDayEnd.getTime();
      this.filter.timeType = 1;
      this.filter.orderStatus = 0;
      this.batchSearchValShow = '';
    },
    currentChange(val) {
      this.currentPage = val;
      this.axiosRequest();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleSearch();
    },
    axiosRequest() {
      const options = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ...this.cache
      };
      axios.post(api.orderTrackListOrder, options).then(res => {
        this.tableData.data = res.data.data || [];
        this.tableData.total = res.data.total;
        if (this.tableData.data.length > 0) {
          this.$nextTick(() => {
            this.handleChecked(this.tableData.data);
          });
        }
      });
    },
    handleChecked(rows) {
      rows.forEach(row => {
        if (row.supportDownload) {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        }
      });
      this.multiselectList = rows.filter(el => el.supportDownload);
    },
    handleShowMore() {
      this.batchSearchVisable = true;
      this.batchSearchTypeErr = false;
      this.batchSearchValErr = false;
      this.batchSearchVal = '';
      this.batchSearchType = '';
    },
    handleBatchSearch() {
      if (!this.batchSearchType) {
        this.batchSearchTypeErr = true;
        return;
      }
      if (!this.batchSearchVal) {
        this.batchSearchValErr = true;
        return;
      }
      this.batchSearchVisable = false;
      this.batchSearchValShow = `${this.batchSearchTypeList[this.batchSearchType - 1].name}:${this.batchSearchVal}`;
      this.filter.batchSearchVal = this.batchSearchVal;
      this.filter.batchSearchType = this.batchSearchType;
      this.handleSearch();
    },
    showOrderDetail: function (row) {
      var url = './orderdetail.html#/' + row.orderNumber;
      window.open(url);
    },
    multiselect(val) {
      this.multiselectList = val;
    },
    isSelect(row, index) {
      if (row.supportDownload) {
        return 1;
      } else {
        return 0;
      }
    },
    // 查看轨迹样式
    handleViewTrackStyle() {
      this.orderTrackVisble = true;
    },
    // 单个下载
    handleDownload(row) {
      axios.post(api.orderTrackDownloadOne, { orderNumber: row.orderNumber }).then(res => {
        window.open(res.data.ticket);
      });
    },
    // 全部下载
    handleDownloadAll() {
      const options = {
        ...this.cache
      };
      axios.post(api.orderTrackPackageAll, options).then(res => {
        this.$message.success('打包成功后，文件可在‘下载管理’中下载');
      });
    },
    // 批量下载
    handleDownloadBatch() {
      const orderNumberList = this.multiselectList.map(el => el.orderNumber);
      axios.post(api.orderTrackPackageBatch, { orderNumberList }).then(res => {
        this.$message.success('打包成功后，文件可在‘下载管理’中下载');
      });
    },
    openBill() {
      this.billNumStr = '';
      this.billNumDialogVisible = true;
    },
    async handleBillNumDownload() {
      await axios.post(api.downloadTrackPicByBillNum, { billNumStr: this.billNumStr });
      this.$message.success('打包成功后，文件可在‘下载管理’中下载');
      this.billNumDialogVisible = false;
    },
    // 查询下载结果
    handleMangeDownload() {
      axios
        .post(api.orderTrackDownloadTask, {
          pageNum: this.downloadCurrentPage,
          pageSize: this.downloadPageSize
        })
        .then(res => {
          this.downloadData.data = res.data.data || [];
          this.downloadData.total = res.data.total;
          if (!this.showDownloadTask) this.showDownloadTask = true;
        });
    },
    downloadCurrentChange(val) {
      this.downloadCurrentPage = val;
      this.handleMangeDownload();
    },
    // 下载压缩包
    hanldeDownloadPackage(row) {
      axios
        .post(api.orderTrackDownloadPackage, {
          id: row.id
        })
        .then(res => {
          window.oepn(res.data.ticket);
          this.showDownloadTask = false;
        });
    }
  }
};
</script>
<style scoped>
.font-ca {
  color: #aaa;
}
.font-gray {
  color: #5b656d;
}
.order-track-map {
  margin: 15px;
}
.order-selected-num {
  color: #58626b;
}
.pagination-fix-download {
  padding-left: 0;
}
</style>
<style>
.batchSearch-custom-dialog {
  width: 536px;
}
.orderTrack-custom-dialog {
  width: 940px;
}
.orderTrack-custom-dialog img {
  width: 100%;
  height: 100%;
}
.batch-search-icon {
  display: block;
  background: url('../../assets/img/wallet/ico_sdfh_gd@2x.png') no-repeat;
  width: 17px !important;
  height: 15px !important;
  background-size: 17px 15px !important;
  margin-top: 10px;
  cursor: pointer;
}
</style>
